'use client'

import { useEffect, useState } from 'react'
import { usePathname } from 'next/navigation'
import DeliveryAppContext from '@/context/deliveryApp/DeliveryAppContext'
import { getNavigationValues } from '@/utils/navigationUtils'

const DeliveryAppProvider = ({ children, locale = 'es_AR', pageProps }) => {
  const pathname = usePathname()
  const {
    currentScreen,
    showHeaderBar,
    showVariantHeaderBar,
    showThemeIcon,
    showCloseIcon,
    showFooterBar
  } = getNavigationValues(pathname)
  const { orders, ordersErrors } = pageProps

  const [driver, setDriver] = useState({
    camioneta: orders?.me?.camioneta,
    ...orders?.me?.legacyVanDriverToday
  })
  const [showDeliverButton, setShowDeliverButton] = useState(false)
  const [ordersToday, setOrdersToday] = useState(
    orders?.me?.ordersToDeliverToday
  )
  const [wazeWindow, setWazeWindow] = useState(null)

  useEffect(() => {
    setOrdersToday(orders?.me?.ordersToDeliverToday)
  }, [orders])

  return (
    <DeliveryAppContext.Provider
      value={{
        currentScreen,
        showHeaderBar,
        showThemeIcon,
        showCloseIcon,
        showVariantHeaderBar,
        showFooterBar,
        driver,
        setDriver,
        showDeliverButton,
        setShowDeliverButton,
        ordersToday,
        setOrdersToday,
        wazeWindow,
        setWazeWindow,
        ordersErrors,
        pageProps
      }}
    >
      {children}
    </DeliveryAppContext.Provider>
  )
}

export default DeliveryAppProvider
